<template>
  <span>
    <ConnectedAccountOnboardingModal
      title="wooCommerce"
      :logo="wooCommerce"
      :success="success"
      :disconnected="disconnected"
      :error="errors.woocommerce"
      logo-alt="WooCommerce logo"
      @click="openModal"
    />

    <ModalWoocommerce
      ref="wooCommModal"
      @error="$emit('error', SALES_PLATFORMS.WOOCOMMERCE)"
      @submit="(payload) => $emit('submit', payload)"
      @modalAction="
        (platformName, action) => $emit('modalAction', platformName, action)
      "
    />
  </span>
</template>

<script>
import { SALES_PLATFORMS } from '@/data/platforms';

import ConnectedAccountOnboardingModal from '@/pages/connected-accounts/components/ConnectedAccountOnboardingModal.vue';
import ModalWoocommerce from '@/pages/connected-accounts/components/modals/ModalWoocommerce.vue';

import wooCommerceIcon from '@/assets/logos/woo-commerce.png';

export default {
  components: {
    ConnectedAccountOnboardingModal,
    ModalWoocommerce,
  },
  props: {
    success: Boolean,
    disconnected: Boolean,
    errors: Object,
  },
  computed: {
    wooCommerce: () => wooCommerceIcon,
  },
  methods: {
    openModal() {
      this.$emit('tileClick', SALES_PLATFORMS.WOOCOMMERCE);
      this.$refs.wooCommModal.open();
    },
  },
};
</script>
